import configLocalJson from './local.json';
import configDevJson from './dev.json';
import configStageJson from './stage.json';
import configProdJson from './production.json';
import {getEnvironment} from '../utils/Environment';

/* istanbul ignore next */
if (typeof window === 'undefined') {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	global.window = {};
}
/* istanbul ignore else */
if (!window.CONFIG) {
	const env = getEnvironment();
	switch (env) {
		case 'local':
			window.CONFIG = configLocalJson;
			break;
		case 'dev':
			window.CONFIG = configDevJson;
			break;
		case 'stage':
			window.CONFIG = configStageJson;
			break;
		case 'prod':
			window.CONFIG = configProdJson;
			break;
		default:
			window.CONFIG = configProdJson;
			window.cchome.util.logger.warn('index.js', 'Didn\'t find window.ENV, setting window.ENV to prod', env);
			break;
	}
}

function getConfig(key) {
	return window.CONFIG[key];
}

getConfig.config = window.CONFIG;
getConfig.json = JSON.stringify(window.CONFIG);

export default getConfig;
